
export default {
	baseurl(){
        let version = process.env.NODE_ENV;
        switch (version) {
            case "development": //开发版
                return '/admin'
            case 'production': //正式版
                return "https://api.chinazby.cn/charge/public/index.php" //公司
                // return "https://api.cheanbao.cn/api/public/index.php" //客户
            default: //未知,默认调用正式版
                return "https://api.chinazby.cn/charge/public/index.php" //公司
                // return "https://api.cheanbao.cn/api/public/index.php" //客户
        }
    },

    imgUrl(){
        let version = process.env.NODE_ENV;
        switch (version) {            
            case "development": //开发版
                return "https://api.chinazby.cn/charge/public"
            case 'production': //正式版
                return "https://api.chinazby.cn/charge/public" //公司
                // return "https://api.cheanbao.cn/api/public" //客户
            default: //未知,默认调用正式版
                return "https://api.chinazby.cn/charge/public" //公司
                // return "https://api.cheanbao.cn/api/public" //客户
        }
    },
}